import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { UserAuth } from "./authContext";

const LeaderRoutes = () => {
    const { user } = UserAuth(); // Get user from context
    const [isLoading, setIsLoading] = useState(true); // Loading state
    const [isLeader, setisLeader] = useState(false); // Admin state

    useEffect(() => {
        const checkAdminStatus = () => {
            // Check if user is authenticated and retrieve admin status from localStorage
            if (user) {
                const storedAdminStatus = JSON.parse(localStorage.getItem('isLeader'));
                setisLeader(storedAdminStatus || false); // Set isLeader to the stored value, or false if not available
            }
            setIsLoading(false); // End loading state
        };

        checkAdminStatus();
    }, [user]);

    if (isLoading) {
        return <div>Loading...</div>; // Show a loading spinner or message while checking
    }

    // If the user is an admin, allow access; otherwise, redirect to home
    return isLeader ? <Outlet /> : <Navigate to="/home" />;
};

export default LeaderRoutes;
